import React, { useState } from 'react';
import Button from '../../../../Components/Button/Button';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import DENTModalOverviewPathologyDecay from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyDecay/DENTModalOverviewPathologyDecay';
import useToothPathologyDecaySurfaces from '../../Hooks/Tooth/Pathology/useToothPathologyDecaySurfaces';

const DENTToothQuickPathologyModalDecayButtons = () => {
	const [showSurfaces, setShowSurfaces] = useState(false);
	const {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
		decayIndex,
		setDecayIndex,
	} = useToothPathologyDecaySurfaces();

	const surfaces = {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
	};

	return (
		<>
			{showSurfaces ? (
				<>
					<DENTModalOverviewSurfaces
						surfaces={surfaces}
						onSelectSurface={handleSelectSurface}
					/>
					<Button
						title={
							'patientTreatment.meddiDENT.dentalCross.quickAdjustment.hideSurfaces'
						}
						onClick={() => setShowSurfaces(false)}
					/>
				</>
			) : (
				<Button
					title={
						'patientTreatment.meddiDENT.dentalCross.quickAdjustment.showSurfaces'
					}
					onClick={() => setShowSurfaces(true)}
				/>
			)}
			<DENTModalOverviewPathologyDecay
				decayIndex={decayIndex}
				setDecayIndex={setDecayIndex}
			/>
		</>
	);
};

export default DENTToothQuickPathologyModalDecayButtons;
